import {
  HomeIcon,
  SearchIcon,
  PlusIcon,
  DownloadIcon,
  SwapIcon,
  EditIcon,
  UploadIcon,
  CalendarIcon,
  FileIcon,
  UserIcon,
  SettingsIcon,
} from '../../../atoms/NavIcons';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import { SvgIconProps } from '@mui/material';

type IconComponent = (props: SvgIconProps) => React.JSX.Element;

const sectionIconMap: Record<string, IconComponent> = {
  Home: HomeIcon,
  Search: SearchIcon,
  Create: PlusIcon,
  Import: DownloadIcon,
  Movements: SwapIcon,
  'Bulk Update': EditIcon,
  Receive: DownloadIcon,
  Dispatch: UploadIcon,
  Attendance: CalendarIcon,
  'My Reports': FileIcon,
  Users: UserIcon,
  Settings: SettingsIcon,
  Services: AssignmentOutlined as unknown as IconComponent,
  Structure: NearMeOutlined as unknown as IconComponent,
  Parts: BuildOutlined as unknown as IconComponent,
  Shipments: LocalShippingOutlined as unknown as IconComponent,
  Reports: FileIcon,
  Configure: SettingsIcon,
};

export const getIconForSection = (name: string): IconComponent =>
  sectionIconMap[name] ?? HomeIcon;
